<app-payment></app-payment>
<div class="main">
  <app-navbar class="light" [transparentWhileOverId]="'main'"></app-navbar>
  <app-header class="dark" id="main"></app-header>
  <app-package-of-services
    class="lighter"
    id="packages"
    (messageEvent)="receiveMessage($event)"
  ></app-package-of-services>
  <app-terms class="lightest" id="terms"></app-terms>
  <app-sign-instruction class="lighter" id="sign"></app-sign-instruction>
  <!-- <app-review class="dark" id="review"></app-review> -->
  <app-faq class="lighter" id="faq"></app-faq>
  <app-contacts
    class="light"
    id="contacts"
  ></app-contacts>
  <app-footer class="lightest"></app-footer>
</div>

<!-- For app-contacts if form appear, add line: 
[subscriptionLevelMessage]="sentMessage"
-->
